import { ReplyToMessageActionOptions } from './actions/replyToMessage';
import { ComposeViewState } from 'owa-mail-compose-store';
import safelyGetSmartReplyExtractionId from './utils/safelyGetSmartReplyExtractionId';
import { isGroupScenario } from 'owa-mail-compose-store/lib/utils/isGroupComposeViewState';
import { InstrumentationContext } from 'owa-mail-store';
import { ClientItemId } from 'owa-client-ids';
import { ActionSource } from 'owa-analytics-actions';

export { ComposeOperation } from 'owa-mail-compose-store';

const MailComposeSendDp = 'MailComposeSend';

export { MailComposeSendDp };

export default {
    MailComposeReply: {
        name: 'MailComposeReply',
        options: { isQos: true },
        customData: (options: ReplyToMessageActionOptions) => [
            options.actionSource,
            options.useFullCompose,
        ],
        actionSource: (options: ReplyToMessageActionOptions) => options.actionSource,
        cosmosOnlyData: (options: ReplyToMessageActionOptions) => options.referenceItemId,
    },
    MailComposeReplyAll: {
        name: 'MailComposeReplyAll',
        options: { isQos: true },
        customData: (options: ReplyToMessageActionOptions) => [
            options.actionSource,
            options.useFullCompose,
        ],
        actionSource: (options: ReplyToMessageActionOptions) => options.actionSource,
        cosmosOnlyData: (options: ReplyToMessageActionOptions) => options.referenceItemId,
    },
    MailComposeForward: {
        name: 'MailComposeForward',
        options: { isQos: true },
        customData: (
            referenceClientItemId: ClientItemId,
            actionSource: ActionSource,
            instrumentationContexts: InstrumentationContext[],
            state?: any
        ) => [actionSource],
        actionSource: (
            referenceClientItemId: ClientItemId,
            actionSource: ActionSource,
            instrumentationContexts: InstrumentationContext[],
            state?: any
        ) => actionSource,
        cosmosOnlyData: (
            referenceClientItemId: ClientItemId,
            actionSource: ActionSource,
            instrumentationContexts: InstrumentationContext[],
            state?: any
        ) => referenceClientItemId && referenceClientItemId.toString(),
    },
    // MailComposeSendE2E captures all send relating javascript across all scenarios.
    // This includes async/sync/delayed send scenarios and is 100% javascript coverage.
    MailComposeSendE2E: {
        name: 'MailComposeSendE2E',
        customData: (viewState: ComposeViewState) => ({
            composeTraceId: viewState.logTraceId,
            operation: viewState.operation,
            isGroupScenario: isGroupScenario(viewState),
        }),
    },
    MailComposeSave: { name: 'MailComposeSave' },
    MailComposeUpConvert: { name: 'MailComposeUpConvert' },

    ComposeCommandDiscardCompose: {
        name: 'ComposeCommandDiscardCompose',
        customData: (viewState: ComposeViewState) => ({
            composeTraceId: viewState.logTraceId,
            wasEmptyBody: viewState.initialContent === viewState.content,
            wasEmptySubject: viewState.subject === '',
        }),
        options: {
            // TODO: 36033 Re-enable sampling after smart reply experiment
            isCore: true,
        },
        cosmosOnlyData: (viewState: ComposeViewState) => {
            return JSON.stringify({
                smartReplyExtractionId: safelyGetSmartReplyExtractionId(viewState),
            });
        },
    },

    ComposeCommandShowFrom: {
        name: 'ComposeCommandShowFrom',
    },

    ComposeCommandSetImportance: {
        name: 'ComposeCommmandSetImportance',
        customData: (viewState: any, importance: any) => [importance],
    },
};
